var _regeneratorRuntime = require("C:\\Users\\Administrator\\Desktop\\Solidity\\EtherSplit\\client\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\Administrator\\Desktop\\Solidity\\EtherSplit\\client\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var StatusError = require("./statuserror");

var Utils = require("./utils");

var Reason = require("./reason");
/*
  Handlers for events emitted by `send` / `call` etc.
 */


var handlers = {
  // ----------------------------------- Constants -------------------------------------------------
  maxConfirmations: 24,
  // Maximum number of confirmation web3 emits
  defaultTimeoutBlocks: 50,
  // Maximum number of blocks web3 will wait before abandoning tx
  timeoutMessage: '50 blocks',
  // Substring of web3 timeout error.
  // -----------------------------------  Helpers --------------------------------------------------

  /**
   * Parses error message and determines if we should squash block timeout errors at user's request.
   * @param  {Object} context execution state
   * @param  {Object} error   error
   * @return {Boolean}
   */
  ignoreTimeoutError: function ignoreTimeoutError(context, error) {
    var timedOut = error.message && error.message.includes(handlers.timeoutMessage);
    var shouldWait = context.contract && context.contract.timeoutBlocks && context.contract.timeoutBlocks > handlers.defaultTimeoutBlocks;
    return timedOut && shouldWait;
  },

  /**
   * Attaches Truffle specific handlers to all of the events emitted by a web3 method.
   * @param {Object}       context  execution state
   * @param {PromiEvent}   emitter  promiEvent returned by a web3 method call
   */
  setup: function setup(emitter, context) {
    emitter.on('error', handlers.error.bind(emitter, context));
    emitter.on('transactionHash', handlers.hash.bind(emitter, context));
    emitter.on('confirmation', handlers.confirmation.bind(emitter, context));
    emitter.on('receipt', handlers.receipt.bind(emitter, context));
  },
  // -----------------------------------  Handlers -------------------------------------------------

  /**
   * Error event handler. Emits error unless error is block timeout and user has
   * specified we should wait longer
   * @param  {Object} context   execution state
   * @param  {Object} error     error
   */
  error: function error(context, _error) {
    if (!handlers.ignoreTimeoutError(context, _error)) {
      context.promiEvent.eventEmitter.emit('error', _error);
      this.removeListener('error', handlers.error);
    }
  },

  /**
   * Transaction hash event handler. Attaches the hash to the context object
   * so it can be attached to the contract instance after a deployment resolves.
   * @param  {Object} context   execution state
   * @param  {String} hash      transaction hash
   */
  hash: function hash(context, _hash) {
    context.transactionHash = _hash;
    context.promiEvent.eventEmitter.emit('transactionHash', _hash);
    this.removeListener('transactionHash', handlers.hash);
  },
  confirmation: function confirmation(context, number, receipt) {
    context.promiEvent.eventEmitter.emit('confirmation', number, receipt); // Per web3: initial confirmation index is 0

    if (number === handlers.maxConfirmations + 1) {
      this.removeListener('confirmation', handlers.confirmation);
    }
  },

  /**
   * Receipt event handler. This handler decodes the event logs, re-emits the receipt,
   * and (for method calls only) resolves/rejects the promiEvent with the receipt.
   * @param  {Object} context   execution state
   * @param  {Object} receipt   transaction receipt
   */
  receipt: function () {
    var _receipt2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(context, _receipt) {
      var logs, reason, error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Decode logs
              _receipt.logs ? logs = Utils.decodeLogs.call(context.contract, _receipt.logs) : logs = []; // Emit receipt

              context.promiEvent.eventEmitter.emit('receipt', _receipt); // .new(): Exit early. We need the promiEvent to resolve a contract instance.

              if (!context.onlyEmitReceipt) {
                _context.next = 5;
                break;
              }

              context.receipt = _receipt;
              return _context.abrupt("return");

            case 5:
              if (_receipt.status) {
                _context.next = 11;
                break;
              }

              _context.next = 8;
              return Reason.get(context.params, context.contract.web3);

            case 8:
              reason = _context.sent;
              error = new StatusError(context.params, _receipt.transactionHash, _receipt, reason);
              return _context.abrupt("return", context.promiEvent.reject(error));

            case 11:
              // This object has some duplicate data but is backward compatible.
              context.promiEvent.resolve({
                tx: _receipt.transactionHash,
                receipt: _receipt,
                logs: logs
              });
              this.removeListener('receipt', handlers.receipt);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function receipt(_x, _x2) {
      return _receipt2.apply(this, arguments);
    }

    return receipt;
  }()
};
module.exports = handlers;